import { useMutation } from "@tanstack/react-query";
import { client } from "@/api/client";
import { handleError } from "@/api/error";
import { queryClient } from "@/providers/QueryClientProviderWrapper";

type RevokeInvitePayload = {
  id: string;
};
export const useRevokeInvite = () => {
  return useMutation({
    mutationFn: async (payload: RevokeInvitePayload) => {
      const res = await client.admin.invitation[":id"].revoke.$post({
        param: payload,
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "invitation"] });
    },
  });
};
